// ==================== Token Utility ====================
// Single source of truth for auth token storage keys and helpers.

export const TOKEN_KEY = 'token';
export const REFRESH_TOKEN_KEY = 'refresh_token';

/** Read the current access token from localStorage */
export const getAccessToken = () => localStorage.getItem(TOKEN_KEY);

/** Read the current refresh token from localStorage */
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);

/**
 * Persist tokens. Refresh token is optional — only written when provided.
 * @param {string} token - The new access token
 * @param {string} [refreshToken] - The new refresh token (omit to keep existing)
 */
export const setTokens = (token, refreshToken) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  if (refreshToken) localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
};

/** Remove both access and refresh tokens from localStorage */
export const clearTokens = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};
